(function () {
    'use strict';

    angular
        .module('app')
        .factory('clientAuthService', clientAuthService);

    clientAuthService.$inject = ['$http', '$q', '$interval'];

    function clientAuthService($http, $q, $interval) {

        if (!window.location.origin) {
            window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
        }


        var port = window.location.protocol === "http:" ? 33552: 33553;
        var CLIENTAUTHURL = window.location.protocol + "//localhost:" + port;


        var service = {
            getLocalUser: getLocalUser
        };
        

        var httpRequest = function(type, url, data) {
            var deferred = $q.defer();
            $.ajax({
                type: type,
                url: url,
                data: data,
                success: function (result) {
                    deferred.resolve(result);
                },
                error: function (request, status, error) {
                    deferred.reject(error);
                }
            });
            return deferred.promise;
        }

        return service;

        
        function getLocalUser() {
            var deferred = $q.defer();
            //check to see if checkClientAuth is running
            checkClientAuth().then(function (data) {
                httpRequest("GET", CLIENTAUTHURL + "/getuser").then(function (data) {
                    deferred.resolve(JSON.parse(data));
                }, function () {
                    deferred.reject();
                });
            }, function (error) {
                //if the viewer is not running or could not launce it should display a message
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function checkClientAuth() {
            var deferred = $q.defer();

            httpRequest("GET", CLIENTAUTHURL).then(function (data) {
                deferred.resolve(data);
            }, function (error) {
                var secure = window.location.protocol == "http:" ? "false" : "true";
                navigateURI("jnlp:" + window.location.origin + '/synergis.webapi/api/account/AuthenticatorJNLP?secure=' + secure + '&webapiurl=' + window.location.origin + "/synergis.webapi");
                //deployJava.launchWebStartApplication(window.location.origin + '/synergis.webapi/api/view/jnlp?secure=' + secure + '&webapiurl='+ window.location.origin + "/synergis.webapi");
                waitForService().then(function (param) {
                    deferred.reject();
                }, function () {
                    deferred.resolve();
                });
            });;
            return deferred.promise;
        }

        function navigateURI(uri, name) {
            window.protocolCheck(uri, function () {
                alert("Please install Java");
            });
        }

        function waitForService() {
            var interval = $interval(function () {
                httpRequest("GET", CLIENTAUTHURL).then(function () {
                    $interval.cancel(interval);
                });
            }, 1000, 60);
            return interval;
        }
    }
})();